import { render, staticRenderFns } from "./icon-warning-fill.vue?vue&type=template&id=885504dc&scoped=true&"
var script = {}
import style0 from "./icon-warning-fill.vue?vue&type=style&index=0&id=885504dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885504dc",
  null
  
)

export default component.exports